export const SUCCESS_FEE_IT = {
  backCta: 'Torna al servizio',
  moreInfo: 'Maggiori informazioni',
  successFee: {
    title: 'Success Fee',
    footer: 'Totale success fee',
    successFeeFromSalary: {
      title:
        '$t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) di RAL',
      description:
        'Package $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" }) per la % di fee indicata nel contratto $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }).<br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitOffer: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Premio variabile calcolato come la percentuale $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) del valore massimo del bonus percepibile dal Profilo su base annua. <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ bonusBenefit.amount }}", "currency": "{{ currency }}" })',
    },
    bonusBenefitSalary: {
      title: '{{ bonusBenefit.description }}',
      description:
        'Premio variabile genericamente indicato calcolato come la percentuale $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) della RAL del profilo. <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ bonusBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    carBenefit: {
      title: 'Assegnazione auto',
      description:
        'Valore di $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" }) stabilito a contratto per assegnazione dell\'autovettura aziendale conteggiato nella misura del $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }). <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.monetary, { "value": "{{ companyCarBenefit.value }}", "currency": "{{ currency }}" })',
    },
    healthInsuranceBenefit: {
      title: 'Assicurazioni sanitarie',
      description:
        'Quota derivante dalle assicurazioni sanitarie nella misura del $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }). <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ healthInsuranceBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    accommodationBenefit: {
      title: 'Eventuale numero di mesi alloggio',
      description:
        'Quota derivante dall\'alloggio nella misura del $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }). <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ accommodationBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
      // Questa descrizione non corrisponde esattamente alla cifra mostrata, che dipende anche dal numero di mesi dell'accommodation.
    },
    stockOptionsBenefit: {
      title: 'Stock options / partecipazioni societarie',
      description:
        'Quota derivante dalle Stock options/partecipazioni societarie nella misura del $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }). <br/>Calcolo: $t(common.formatting.percentage, { "value": "{{ successFeePercentageOfCompensationPackage }}" }) * $t(common.formatting.percentage, { "value": "{{ stocksBenefit.percentage }}" }) * $t(common.formatting.monetary, { "value": "{{ annualSalaryValue }}", "currency": "{{ currency }}" })',
    },
    overallFee: {
      title: 'Fee complessiva',
    },
    minimumSuccessFeeAmount: {
      title: 'Minimale',
      description:
        'In accordo col contratto firmato il valore della fee complessiva è stato impostato a $t(common.formatting.monetary, { "value": "{{ minimumAmount }}", "currency": "{{ currency }}" }) (minimale)',
    },
  },
  prePayments: {
    title: 'Acconti già fatturati',
    footer: 'Totale acconti',
    retainerFee: {
      title: 'Retainer fee',
    },
    confidenceFee: {
      title: 'Confidence fee',
    },
  },
  total: {
    title: 'Totale',
    successFee: {
      title: 'Success fee',
    },
    prePayments: {
      title: 'Eventuali acconti a voi già fatturati',
    },
    discount: {
      title:
        'Sconto concordato ($t(common.formatting.percentage, { "value": "{{ discountPercentage }}" }))',
    },
    minimumSuccessFeeAmount: {
      title: '$t(successFee.successFee.minimumSuccessFeeAmount.title)',
      description:
        '$t(successFee.successFee.minimumSuccessFeeAmount.description)',
    },
  },
};
